/**
 * /particuliers/aides/coup-de-pouce
 * ─────────────────────────────────────────────────────────────────
 * Guide éditorial complet (long-form) sur les Coups de pouce CEE.
 *
 * Composé du composant `CoupDePouceGuide` (hero, mécanisme, dispositifs
 * en vigueur, barèmes Anah, conditions, démarches, cumul, FAQ, CTA).
 *
 * Contenu factuel : `client/src/config/coup-de-pouce-content.ts`.
 */

import { CoupDePouceGuide } from '../../../../components/aides/CoupDePouceGuide';

export default function CoupDePoucePage() {
  return <CoupDePouceGuide />;
}
